export default __webpack_public_path__ + "static/media/move.4dba4ed6.mp4";